let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cw6Fw")).then(() => parcelRequire('5g2dy'));